// Nav entry of Letters (shell/nav.ts collects every routes/*.nav.ts; `order` places it in the rail, the tabs and Lisää).
import { defineNav } from '../shell/nav-entry';

export const nav = defineNav({
  id: 'letters',
  path: '/letters',
  icon: 'letters',
  group: 'together',
  phone: 'more',
  order: 1100,
  load: () => import('./Letters'),
});
